
import { useIdleTimer } from 'react-idle-timer';
import { Navigate, Outlet } from 'react-router-dom';
import { useKioskContext } from '../../store/Context';

const PrivateRoutes = () => {
  const { restart } = useKioskContext();
  const personId = localStorage.getItem('personId');
  const sessionId = localStorage.getItem('sessionId');

  const isValidated = Boolean(personId && sessionId);
  useIdleTimer({
    timeout: 20000,
    onIdle: restart,
  });

  if (!isValidated) {
    return <Navigate replace to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
